import AnalyticsEventsEnum from '@enums/analytics-events-enum';
import {
  messagePayload,
  offerPayload,
  enquiryUuidPayload,
  userPayload,
  identifyPayload,
  rankingPayload,
  errorPayload,
} from './payloads';

export function trackUserLoggedIn(user) {
  const payload = identifyPayload(user);

  identify(payload.user_id, payload);
  track(AnalyticsEventsEnum.USER_LOGGED_IN, payload);
}

export function trackUserLoggedOut(user) {
  const payload = userPayload(user);

  track(AnalyticsEventsEnum.USER_LOGGED_OUT, payload);
}

export function trackUserLoginError(user, error) {
  const payload = errorPayload(user, error);

  track(AnalyticsEventsEnum.USER_LOGIN_ERROR, payload);
}

export function trackOfferExpanded(user, enquiry, offer) {
  const payload = offerPayload(user, enquiry, offer);

  track(AnalyticsEventsEnum.OFFER_EXPANDED, payload);
}

export function trackOfferEnquired(user, enquiry, offer) {
  const payload = offerPayload(user, enquiry, offer);

  track(AnalyticsEventsEnum.OFFER_ENQUIRED, payload);
}

export function trackRankingUpdated(user, enquiry, rankingPreference, stage) {
  const payload = rankingPayload(user, enquiry, rankingPreference, stage);

  track(AnalyticsEventsEnum.RANKING_PREFERENCE_UPDATED, payload);
}

export function trackOfferAccepted(user, enquiry, offer) {
  const payload = offerPayload(user, enquiry, offer);

  track(AnalyticsEventsEnum.OFFER_ACCEPTED, payload);
}

export function trackDisableAutoAccept(user, enquiry) {
  const payload = enquiryUuidPayload(user, enquiry);

  track(AnalyticsEventsEnum.AUTO_ACCEPT_DISABLED, payload);
}

export function trackExtendDecisionPeriod(user, enquiry) {
  const payload = enquiryUuidPayload(user, enquiry);

  track(AnalyticsEventsEnum.DECISION_PERIOD_EXTENDED, payload);
}

export function trackMessageSent(enquiry, provider, message) {
  const payload = messagePayload(enquiry, provider, message);

  track(AnalyticsEventsEnum.MESSAGE_SENT, payload);
}

export function track(event, payload) {
  if (shouldNotTrack()) {
    return;
  }

  window.analytics.track(event, payload);
}

export function identify(id, payload) {
  if (shouldNotTrack()) {
    return;
  }

  window.analytics.identify(id, payload);
}

/*
** Only run on client-side and only in non-test environment
*/
export function shouldNotTrack() {
  return typeof process.browser === 'undefined'
    || !process.env.VUE_APP_ANALYTICS_ON
    || process.env.VUE_APP_ANALYTICS_ON === 'false';
}
